import {
    ROOT,
    GET_PMS_RATE,
    GET_DETAIL_PMS_RATE,
    UPDATE_PMS_RATE,
    DELETE_RATE_PMS_RATE
} from "@/_helpers/constant.js";
import { requestOptions, handleResponse } from "@/_helpers";

//#region list of rooms
function getPmsRate(data) {
    return fetch(ROOT + GET_PMS_RATE, requestOptions.post(data))
        .then(handleResponse)
        .then(data => {
            return data;
        });
}
function getDetailPmsRate(data) {
    return fetch(ROOT + GET_DETAIL_PMS_RATE, requestOptions.post(data))
        .then(handleResponse)
        .then(data => {
            return data;
        });
}
function UpdatePmsRate(data) {
    return fetch(ROOT + UPDATE_PMS_RATE, requestOptions.post(data))
        .then(handleResponse)
        .then(data => {
            return data;
        });

}
function deleteDatePmsRate(id) {
    return fetch(ROOT + DELETE_RATE_PMS_RATE + `/${id}`, requestOptions.get())
        .then(handleResponse)
        .then(data => {
            return data;
        });

}
//#endregion
export const PmsRateService = {
    getPmsRate,
    getDetailPmsRate,
    UpdatePmsRate,
    deleteDatePmsRate
};
